import $ from 'jquery';
import 'slick-carousel'; // TODO We need to replace, as it`s based on jQuery

export default class MediaHeader {
	constructor() {
		this.mediaWrapper = $('.atl-media-header');
		this.slickSlider = this.mediaWrapper.find('.slick-slider');
	}

	init(window) {
		if (!this.mediaWrapper.length) {
			return;
		}
		if (this.slickSlider.length > 0) {
			this.slickSlider.slick();
		}

		const videoContainer = this.mediaWrapper.find('video');
		const videoObject = videoContainer[0];
		if (videoContainer.length > 0) {
			this.mediaWrapper.find('button.sound-button').on('click', (event) => {
				$(event.delegateTarget).toggleClass('enabled');
				if (videoObject.muted) {
					videoObject.muted = false;
				} else {
					videoObject.muted = true;
				}
			});

			if ($(window).width() < 992) {
				videoObject.muted = false;
				this.mediaWrapper.find('button.sound-button').addClass('enabled');
				this.mediaWrapper.find('button.play-pause-button').addClass('pause');
			} else {
				videoObject.muted = true;
				this.mediaWrapper.find('button.sound-button').removeClass('enabled');
				videoObject.play();
				this.mediaWrapper.find('button.play-pause-button').addClass('play');
			}

			// Mobile Play Button for header Video
			this.mediaWrapper
				.find('button.play-pause-button')
				.on('click', (event) => {
					$(event.delegateTarget).addClass('clicked');
					$(event.delegateTarget).toggleClass('play');
					if ($(event.delegateTarget).hasClass('play')) {
						$(event.delegateTarget).removeClass('pause');
						videoObject.play();
					} else {
						$(event.delegateTarget).addClass('pause');
						videoObject.pause();
					}
				});
		}
	}
}

export let mediaHeader;

$(document).ready(() => {
	mediaHeader = new MediaHeader();
	const win = $(window);
	mediaHeader.init(win);
});
